import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../../../../../app.config';
import { PaypalButton } from '../../../../models/paypal/paypalButton';

export interface PaypalButtonProperties {
  autoImportButtonId: string;
  paypalActionUrl: string;
  premiumButtonId: string;
  premiumNoTrialButtonId: string;
}

export interface PaypalLogDTO {
  actionType: string;
  idUser: number;
  paymentMode: string;
  paypalButtonId: string;
  subscriptionType: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaypalService {
  private httpClient = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly apiUrl: string;
  private readonly publicApiUrl: string;

  constructor() {
    this.apiUrl = `${this.config.api}/api/paypal`;
    this.publicApiUrl = `${this.config.api}/public/api/paypal`;
  }

  public buttonProperties(): Observable<PaypalButton> {
    return this.httpClient.get<PaypalButton>(`${this.publicApiUrl}/buttons`);
  }

  public types(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.apiUrl}/type`);
  }

  public log(payload: PaypalLogDTO): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/log`, payload);
  }

  /** Log a PayPal action (for public/anonymous users) */
  public logPublic(payload: PaypalLogDTO): Observable<any> {
    return this.httpClient.post(`${this.publicApiUrl}/log`, payload);
  }

  /** Alias for log (for clarity) */
  public saveLog(payload: PaypalLogDTO): Observable<any> {
    return this.log(payload);
  }

  /** Cancel an auto import PayPal subscription */
  public cancelPaypalSubscription(subscriptionId: string, requestType: string, userId: number | undefined): Observable<any> {
    return this.httpClient.post(
      `${this.apiUrl}/subscription/${subscriptionId}/cancel/${requestType}/users/${userId}`,
      ''
    );
  }
}